/**
 * Shared Zod schemas for the user-equipment catalog endpoints.
 *
 * Used by the admin UserEquipmentDialog (which calls a parent-supplied
 * `onSave` callback — the dialog keeps its existing local state) and by
 * `POST /api/users/equipment` + `PUT /api/users/equipment/:id` server-side
 * via `parseBody`. Both surfaces share the schema so the contract is
 * defined once.
 */
import { z } from 'zod';

/** Body schema for `POST /api/users/equipment`. */
export const userEquipmentCreateSchema = z.object({
  nameDe: z.string().trim().min(1, { message: 'userEquipment.errors.nameDeRequired' }),
  nameEn: z.string().trim().min(1, { message: 'userEquipment.errors.nameEnRequired' }),
  category: z.string().trim().min(1, { message: 'userEquipment.errors.categoryRequired' }),
  description: z.string().trim().optional(),
});

export type UserEquipmentCreateInput = z.infer<typeof userEquipmentCreateSchema>;

/** Body schema for `PUT /api/users/equipment/:id`. All fields optional. */
export const userEquipmentUpdateSchema = z.object({
  nameDe: z
    .string()
    .trim()
    .min(1, { message: 'userEquipment.errors.nameDeRequired' })
    .optional(),
  nameEn: z
    .string()
    .trim()
    .min(1, { message: 'userEquipment.errors.nameEnRequired' })
    .optional(),
  category: z
    .string()
    .trim()
    .min(1, { message: 'userEquipment.errors.categoryRequired' })
    .optional(),
  description: z.string().trim().optional(),
});

export type UserEquipmentUpdateInput = z.infer<typeof userEquipmentUpdateSchema>;
